import React, { useState } from "react";
import {
  Button,
  Drawer,
  Space,
  Modal,
  Text,
  Container,
  Group,
} from "@mantine/core";
import EmptyStateContainer from "../../../themes/components/EmptyStateContainer";
import PayslipUploadForm from "./PayslipUploadForm";
import DocumentImporterConfiguration from "../services/model/DocumentImporterConfiguration";
import { AnalyticsContext } from "../../../providers/AnalyticsProvider";

type PayslipUploadHistoryTableEmptyStateContainerProps = {
  documentImporterConfiguration: DocumentImporterConfiguration;
};

const PayslipUploadHistoryTableEmptyStateContainer: React.FC<
  PayslipUploadHistoryTableEmptyStateContainerProps
> = ({ documentImporterConfiguration }) => {
  const [opened, setOpened] = useState(false);
  const [exitingUpload, setExitingUpload] = useState(false);
  const [uploadingClicked, setUploadingClicked] = useState(false);

  const { trackDocumentsEvent } = React.useContext(AnalyticsContext);

  return (
    <>
      <Drawer
        opened={opened}
        size="xl"
        onClose={() => {
          if (uploadingClicked) {
            setExitingUpload(true);
          } else {
            setOpened(false);
          }
        }}
        title={`Upload ${documentImporterConfiguration.document_name_plural}`}
        overlayOpacity={0.1}
        overlayBlur={3}
        position="right"
      >
        <PayslipUploadForm
          documentImporterConfiguration={documentImporterConfiguration}
          onSuccess={() => {
            setOpened(false);
            setExitingUpload(false);
            setUploadingClicked(false);
          }}
          setExitingUpload={setExitingUpload}
          setUploadingClicked={setUploadingClicked}
        />
      </Drawer>
      <Modal
        size="40%"
        title={`Do you want to cancel this ${documentImporterConfiguration.document_name_lower_case} upload?`}
        opened={exitingUpload}
        centered
        onClose={() => setExitingUpload(false)}
        closeOnClickOutside
        styles={{
          body: {
            padding: 0,
          },
        }}
      >
        <Container>
          <Space h="xl" />
          <Text size="lg" align="center">
            Closing this window will cancel your current{" "}
            {documentImporterConfiguration.document_name_lower_case} upload
          </Text>
          <Space h="xl" />
          <Group spacing="xl" position="center">
            <Button
              color="red"
              style={{ backgroundColor: "red" }}
              onClick={() => {
                setOpened(false);
                setExitingUpload(false);
              }}
            >
              Cancel Upload
            </Button>
            <Button
              onClick={() => {
                setOpened(true);
                setExitingUpload(false);
              }}
            >
              Continue Upload
            </Button>
          </Group>
          <Space h="xl" />
        </Container>
      </Modal>
      <EmptyStateContainer
        title={`You have no ${documentImporterConfiguration.document_name_plural_lower_case}`}
        description={`Upload your ${documentImporterConfiguration.document_name_plural_lower_case} to distribute to staff via our WhatsApp chat-bot`}
        button={{
          onClick: () => {
            trackDocumentsEvent({
              event: `Upload_${documentImporterConfiguration.document_name_plural}_CTA_Body`,
              description: `User clicked 'Upload ${documentImporterConfiguration.document_name_plural}' button on the ${documentImporterConfiguration.document_name_plural_lower_case} main content section (this will only display if you haven't uploaded ${documentImporterConfiguration.document_name_plural_lower_case} before)`,
              event_type: "CTA:Click",
              type: documentImporterConfiguration.document_name_plural,
              job: null,
            });
            setOpened(true);
          },
          title: `Upload ${documentImporterConfiguration.document_name_lower_case}`,
        }}
      />
    </>
  );
};

export default PayslipUploadHistoryTableEmptyStateContainer;
